import { EntityDtoBase, IdNameDto  } from "./Common";
import { EventProductDto } from "./Event";

export enum ProductType {
    NotSet = 0,
    Internal = 1,
    External = 2
}

export interface ProductDto extends EntityDtoBase {
    productType: ProductType
    name: string
    yearOfPurchased: number
    totalQuantity: number
    note: string
    canBeAssigned: boolean
}

export interface ProductWithStatisticsDto extends ProductDto
{
    statistics: ProductStatisticsDto
    assignedEvents: IdNameDto[]
}

export interface ProductStatisticsDto { 
    operatingTime: string
    revenue: number
    costs: number
    profit: number
    assignedQuantity: number
    netProfitPerPeriod: number
    netProfitPerHour: number
    netProfitPerEvent: number
}

export interface CreateProductDto extends Omit<ProductDto, 'id' | 'createdAt' | 'events'> { }

/**
 * Product in the context of the event
 */
export interface ProductOfEventDto extends EventProductDto {
    /**
     * Product Id
     * Name of product will be resolved on frontend as list of available products must be ready there anyway for dropdown
     */
    productId: string
}
